// @mui
import {TableRow, TableCell, Skeleton} from '@mui/material';

// ----------------------------------------------------------------------

export default function TableSkeleton({count, rows = 1, ...other}) {
    return Array.from(Array(parseInt(rows)).keys()).map((item, index) =>
        <TableRow {...other} key={index}>
            {
                Array.from(Array(count).keys()).map((item, index) => (
                    <TableCell key={index}>
                        <Skeleton variant="text" width={130} height={30}/>
                    </TableCell>
                ))
            }
        </TableRow>
    );
}
